var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0a15 15 0 1 0 0 30 15 15 0 0 0 0-30Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.462 8.25-2.809 14.345s-.12.655-.934.655c-.432 0-.655-.206-.655-.206l-6.085-5.05-2.977-1.5-3.822-1.016s-.68-.197-.68-.76c0-.468.7-.691.7-.691l15.987-6.351c-.001-.001.488-.177.844-.176.22 0 .469.094.469.375 0 .188-.038.375-.038.375Z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.25 19.879-2.57 2.53s-.112.086-.26.09a.37.37 0 0 1-.165-.032l.723-4.474 2.272 1.886Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.423 10.647a.375.375 0 0 0-.526-.07L9 16.5s1.58 4.419 1.82 5.184c.242.766.435.784.435.784l.723-4.474 7.374-6.822a.374.374 0 0 0 .07-.525Z",
    fill: "#F0F0F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.03723f47.svg";
export { ForwardRef as ReactComponent };